// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/illustration-template/src/index.tsx

import baseIllustration from '@bubble-ui/temp-illustration-base';
var IllustrationOnlinePurchasesPath = 'M76 10.5A3.5 3.5 0 0072.5 7H61l-4.6 6H43.6L39 7H27.5a3.5 3.5 0 00-3.5 3.5v79a3.5 3.5 0 003.5 3.5h45a3.5 3.5 0 003.5-3.5V84h7v5.5c0 5.799-4.701 10.5-10.5 10.5h-45C21.701 100 17 95.299 17 89.5v-79C17 4.701 21.701 0 27.5 0h45C78.299 0 83 4.701 83 10.5V18h-7v-7.5zm7.547 55.927l-.005.03c-.321 2.045-2.056 3.548-4.082 3.574H56.54c-2.048-.046-3.764-1.55-4.087-3.604L48.729 44h38.543l-3.725 22.427zM68 31.5c3.283 0 6.015 2.378 6.578 5.5H61.422c.563-3.122 3.295-5.5 6.578-5.5zM81.63 37c-.605-6.992-6.482-12.5-13.63-12.5-7.147 0-13.024 5.508-13.63 12.5h-13.9l5.073 30.542c.842 5.373 5.4 9.363 10.917 9.489h23.044a11.202 11.202 0 0010.95-9.47L95.53 37h-13.9zm-7.204 10.525l4.949 4.95L66.4 65.45l-8.775-8.775 4.949-4.95 3.826 3.826 8.026-8.026z';
var IllustrationOnlinePurchases = baseIllustration('IllustrationOnlinePurchases', {
  getPath: () => IllustrationOnlinePurchasesPath
});

/**
 * @deprecated this component is outdated and will be removed with v6.0.0
 */
export default IllustrationOnlinePurchases;
//# sourceMappingURL=index.js.map